/* eslint-disable func-names */
import { useEffect, useRef, useState } from 'react';

import { useCookies } from 'react-cookie';
import { useSelector } from 'react-redux';

import { useFeatures } from '@atc/features';

import CookieConsentModule from '@/modules/CookieConsentModule.js';

export default function PendoScriptContainer() {
    function loadPendoScript(apiKey, abc) {
        (function (p, e, n, d, o) {
            const v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
            let w; let x;
            // eslint-disable-next-line no-multi-assign
            o = p[d] = p[d] || {};
            o._q = o._q || [];
            for (w = 0, x = v.length; w < x; ++w) {
                (function (m) {
                    o[m] = o[m] || function () {
                        // eslint-disable-next-line prefer-rest-params
                        o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
                    };
                }(v[w]));
            }
            const y = e.createElement(n);
            y.async = !0;
            y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
            const z = e.getElementsByTagName(n)[0];
            z.parentNode.insertBefore(y, z);
        }(window, document, 'script', 'pendo'));
        // This function creates visitors and accounts in Pendo
        // You will need to replace <visitor-id-goes-here> and <account-id-goes-here> with values you use in your app
        // Please use Strings, Numbers, or Bools for value types.
        window.pendo.initialize({
            visitor: {
                id: abc,
            },
        });
    }

    const {
        enable_pendo: [isPendoEnabled],
    } = useFeatures([
        'enable_pendo',
    ]);

    const isPendoLoaded = useRef(false);

    const hasSuppressedCookies = useSelector(CookieConsentModule.duck.selectors.selectHasSuppressedGroup);

    const cookieName = 'abc';
    const [cookies = {}] = useCookies([cookieName]);
    const [abc, setAbc] = useState(cookies[cookieName]);
    const checkCount = useRef(0);

    useEffect(() => {
        let interval;
        if (!abc) {
            interval = setInterval(() => {
                if (checkCount.current > 50) {
                    clearInterval(interval); // Stop checking after 5 seconds
                }
                checkCount.current += 1;
                const cookieValue = document.cookie
                    .split('; ')
                    .find((row) => row.startsWith(`${cookieName}=`));
                if (cookieValue) {
                    setAbc(cookieValue.split('=')[1]);
                    clearInterval(interval); // Stop checking once the cookie is detected
                }
            }, 100); // Check 100 ms
        }

        return () => interval && clearInterval(interval); // Cleanup on unmount
    }, [cookieName, abc]);

    useEffect(() => {
        if (!hasSuppressedCookies && isPendoEnabled && !isPendoLoaded.current) {
            loadPendoScript('125e14c6-efdb-45a7-7cc2-3bd0112916b1', abc);
            isPendoLoaded.current = true;
        }
    }, [hasSuppressedCookies, isPendoEnabled, abc]);
}
